import React from "react";
import { Link } from "react-router-dom";

import Aboutchose from "../../../assets/image/contactus.jpg"

const ServicesHero = () => {
    return (
        <section

            className="relative h-[70vh] flex items-center bg-[#eff2f5]  py-10 md:py-20  bg-cover bg-center bg-no-repeat"
            style={{
                backgroundImage: `url(${Aboutchose})`,
            }}>

            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/60"></div>

            {/* Content */}
            <div className="relative z-10 container  px-4  
 sm:left-10 sm:right-10
 md:left-32 md:right-auto
 top-1/2 -translate-y-1/2
 text-white
 md:w-[50%]">
                <h1 className="text-white text-4xl sm:text-[60px] font-[700]">
             Service
                </h1>

                {/* Red underline */}
                <div className="flex gap-2 my-6 md:my-10">
                    <div className="w-12 h-[3px] bg-[#ec4e4f]"></div>
                    <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                    <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                    <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                </div>

                {/* Breadcrumb */}
                <p className="text-gray-200 text-sm">
                    <Link
                        to="/"
                        className="hover:text-red-500 transition duration-300">Trinity
                    </Link>
                    <span className="mx-2">{">"}</span>
                    <span className="text-white">Service</span>
                </p>
            </div>
        </section>
    );
};

export default ServicesHero;
